var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookkeeperImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 241,
    viewBox: "0 0 250 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.773,
    cy: 120.016,
    r: 120,
    fill: "#EAF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.434 208.796H40.8496V17.7266H171.656L191.434 38.0413V208.796Z",
    fill: "white",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.859 128.008H54.4251V135.908H177.859V128.008Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.859 146.109H54.4251V154.009H177.859V146.109Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.859 164.215H54.4251V172.115H177.859V164.215Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.859 182.32H54.4251V190.221H177.859V182.32Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.859 132.398H55.1001V135.866H177.859V132.398Z",
    fill: "#4D8ED5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.434 132.824V135.44H55.5259V132.824H177.434Z",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 0.851235
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.859 150.395H55.1001V153.752H177.859V150.395Z",
    fill: "#4D8ED5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.434 150.82V153.327H55.5259V150.82H177.434Z",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 0.851235
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M177.859 167.961H55.0962V170.983H177.859V167.961Z",
    fill: "#4D8ED5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M177.434 168.387V170.557H55.522V168.387H177.434Z",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 0.851235
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.859 185.527H55.1001V189.536H177.859V185.527Z",
    fill: "#4D8ED5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.434 185.953V189.11H55.5259V185.953H177.434Z",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 0.851235
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M176.871 72.3828H55.4117V118.905H176.871V72.3828Z",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9577 77.6484V118.026",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M176.913 71.9688H55.37V82.4755H176.913V71.9688Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M176.913 77.1016H56.0415V82.4763H176.913V77.1016Z",
    fill: "#4D8ED5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M176.487 77.5273V82.0508H56.4673V77.5273H176.487Z",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 0.851235
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.658 44.7422H109.079V58.0725H168.658V44.7422Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M168.658 52.3047H109.752V58.0718H168.658V52.3047Z",
    fill: "#4D8ED5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M168.233 52.7305V57.6465H110.178V52.7305H168.233Z",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 0.851235
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171.519 17.6562L171.492 37.982L191.434 38.0374L171.519 17.6562Z",
    fill: "white",
    stroke: "#83B0E1",
    strokeOpacity: 0.2,
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M228.056 180.188C234.004 214.006 207.016 217.271 185.377 217.271C163.737 217.271 139.781 210.74 144.796 178.323C148.19 156.366 160.786 119.551 185.623 119.551C210.463 119.55 224.208 158.305 228.056 180.188Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M228.056 180.179C224.521 160.077 212.632 125.738 191.465 120.285C191.796 120.855 192.133 121.424 192.458 121.999C196.975 129.919 201.518 138.017 204.779 146.556C210.241 160.869 212.98 177.393 206.898 191.963C201.512 204.878 189.679 212.493 175.968 213.623C169.99 214.115 163.601 213.571 157.802 211.637C165.602 215.96 175.718 217.263 185.377 217.263C207.016 217.262 234.004 213.997 228.056 180.179Z",
    fill: "#4D8ED5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M176.929 120.824C176.929 120.824 161.536 109.804 163.81 90.9135C166.516 68.4332 180.732 104.13 199.842 84.2671C213.137 70.4489 205.964 115.401 193.895 120.65L176.929 120.824Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M203.297 81.7728C203.248 90.0094 202.667 99.0836 197.482 105.484C191.158 113.285 179.621 116.417 170.074 113.727C173.47 118.344 176.93 120.824 176.93 120.824L193.896 120.649C204.729 115.939 211.612 79.2481 203.297 81.7728Z",
    fill: "#4D8ED5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M201.159 121.756C201.159 122.915 200.219 123.854 199.06 123.854H170.374C169.214 123.854 168.274 122.915 168.274 121.756V118.84C168.274 117.682 169.214 116.742 170.374 116.742H199.06C200.218 116.742 201.159 117.682 201.159 118.84V121.756Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.959 165.737C183.832 165.507 178.908 164.488 178.908 160.943C178.908 156.947 181.687 154.656 186.527 154.656C190.731 154.656 194.149 157.476 194.149 160.943H206.362C206.362 153.964 200.13 148.08 191.688 146.345V141.715H181.425V146.249C172.543 147.793 166.695 153.405 166.695 160.943C166.695 168.519 174.672 173.856 187.02 174.545C192.983 174.877 194.149 176.555 194.149 179.339C194.149 182.171 190.633 185.627 186.527 185.627C182.324 185.627 178.908 182.807 178.908 179.339H166.695C166.695 186.332 172.955 192.229 181.425 193.951V198.348H191.688V193.891C199.934 192.064 206.362 186.046 206.362 179.339C206.363 171.347 199.654 166.39 187.959 165.737Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M208.955 47.7067C208.955 60.0062 198.985 69.9741 186.688 69.9741C174.388 69.9741 164.417 60.0062 164.417 47.7067C164.417 35.408 174.388 25.4375 186.688 25.4375C198.985 25.4384 208.955 35.4089 208.955 47.7067Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M203.581 47.7048C203.581 57.036 196.019 64.6009 186.687 64.6009C177.355 64.6009 169.791 57.036 169.791 47.7048C169.791 38.3744 177.355 30.8086 186.687 30.8086C196.019 30.8086 203.581 38.3744 203.581 47.7048Z",
    fill: "#4D8ED5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M187.273 45.9468C185.583 45.8531 183.568 45.4352 183.568 43.9838C183.568 42.3486 184.705 41.4114 186.686 41.4114C188.407 41.4114 189.805 42.5665 189.805 43.9838H194.804C194.804 41.1279 192.255 38.7189 188.798 38.0081V36.1133H184.596V37.969C180.961 38.6023 178.567 40.8981 178.567 43.9838C178.567 47.0857 181.832 49.27 186.886 49.5526C189.331 49.6888 189.805 50.3757 189.805 51.5164C189.805 52.6741 188.369 54.0888 186.686 54.0888C184.966 54.0888 183.568 52.9354 183.568 51.5164H178.567C178.567 54.3774 181.13 56.794 184.597 57.498V59.2984H188.798V57.4733C192.175 56.7234 194.805 54.2616 194.805 51.5172C194.804 48.2425 192.06 46.2149 187.273 45.9468Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M162.732 77.6168C162.732 89.9155 152.761 99.8843 140.466 99.8843C128.166 99.8843 118.196 89.9155 118.196 77.6168C118.196 65.3173 128.166 55.3477 140.466 55.3477C152.761 55.3477 162.732 65.3173 162.732 77.6168Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M157.357 77.6141C157.357 86.9462 149.796 94.5119 140.465 94.5119C131.133 94.5119 123.568 86.947 123.568 77.6141C123.568 68.2845 131.133 60.7188 140.465 60.7188C149.796 60.7188 157.357 68.2837 157.357 77.6141Z",
    fill: "#4D8ED5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.05 75.8547C139.36 75.7602 137.344 75.3431 137.344 73.8909C137.344 72.2557 138.482 71.3185 140.464 71.3185C142.184 71.3185 143.583 72.4745 143.583 73.8909H148.583C148.583 71.0359 146.033 68.626 142.575 67.9161V66.0195H138.374V67.8761C134.738 68.5085 132.342 70.8052 132.342 73.8901C132.342 76.9928 135.609 79.1771 140.661 79.4605C143.105 79.5959 143.583 80.2837 143.583 81.4226C143.583 82.582 142.145 83.9951 140.463 83.9951C138.743 83.9951 137.343 82.8425 137.343 81.4226H132.342C132.342 84.2845 134.905 86.7003 138.374 87.4051V89.2055H142.575V87.3796C145.952 86.6313 148.583 84.1679 148.583 81.4235C148.584 78.1513 145.837 76.122 141.05 75.8547Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M248.963 77.6168C248.963 89.9155 238.992 99.8843 226.696 99.8843C214.393 99.8843 204.425 89.9155 204.425 77.6168C204.425 65.3173 214.393 55.3477 226.696 55.3477C238.992 55.3477 248.963 65.3173 248.963 77.6168Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeWidth: 1.34827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M243.587 77.6141C243.587 86.9462 236.024 94.5119 226.695 94.5119C217.363 94.5119 209.798 86.947 209.798 77.6141C209.798 68.2845 217.363 60.7188 226.695 60.7188C236.024 60.7188 243.587 68.2837 243.587 77.6141Z",
    fill: "#4D8ED5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M227.281 75.8547C225.59 75.7602 223.574 75.3431 223.574 73.8909C223.574 72.2557 224.71 71.3185 226.692 71.3185C228.414 71.3185 229.813 72.4745 229.813 73.8909H234.813C234.813 71.0359 232.26 68.626 228.805 67.9161V66.0195H224.603V67.8761C220.968 68.5085 218.573 70.8052 218.573 73.8901C218.573 76.9928 221.837 79.1771 226.891 79.4605C229.334 79.5959 229.812 80.2837 229.812 81.4226C229.812 82.582 228.375 83.9951 226.691 83.9951C224.972 83.9951 223.573 82.8425 223.573 81.4226H218.573C218.573 84.2845 221.134 86.7003 224.603 87.4051V89.2055H228.805V87.3796C232.18 86.6313 234.813 84.1679 234.813 81.4235C234.813 78.1513 232.067 76.122 227.281 75.8547Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookkeeperImg);
export default __webpack_public_path__ + "static/media/bookkeeperImg.38ceca5e2a44efbf648b913a4583016f.svg";
export { ForwardRef as ReactComponent };